import axios from '@axios';

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchEvidenceTypes() {
            return new Promise((resolve, reject) => {
                axios
                    .get('/evidence/types')
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        fetchEvidenceFiles(ctx, { formId }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/evidence/${formId}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        uploadEvidenceFile(ctx, { formId, payload }) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/evidence/${formId}/upload`, payload, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        viewEvidenceFile(ctx, { formId, fileId }) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/evidence/${formId}/${fileId}/view`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        deleteEvidenceFile(ctx, { formId, fileId }) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/evidence/${formId}/${fileId}/delete`)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        submitEvidence(ctx, { formId, payload }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/evidence/${formId}/submit`, payload)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        fetchEvidenceItems(ctx, { evidenceTypeId, formId }) {
            return new Promise((resolve, reject) => {
                const params = formId ? { formId } : {}
                axios
                    .get(`/evidence/items/${evidenceTypeId}`, { params })
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
        saveEvidenceValidation(ctx, { formId, payload }) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/evidence/${formId}/validate`, payload)
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        }
    }
}
